import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {ReCaptcha} from 'react-recaptcha-v3'

import CONSTANTS from '../utils/Constants';

class InvisibleCaptcha extends Component {
	constructor() {
		super();

		this.recaptchaRef = React.createRef();
	}

	componentDidMount() {
		this.scheduleReset();
	}

	componentWillUnmount() {
		this.unSchedule();
	}

	unSchedule = () => {
		if(this.intervalId) {
			clearInterval(this.intervalId);
		}
	}

	scheduleReset = () => {
		this.intervalId = setInterval(() => this.reset(), CONSTANTS.TIMEOUTS.RECAPTCHA); 
	}

	reset = () => {
		if("current" in this.recaptchaRef && this.recaptchaRef.current && this.recaptchaRef.current.state.ready) {
			// Other implementations  have a reset function; we're faking it
			try {
				this.recaptchaRef.current.execute();
			}
			catch(error) {
				console.error("Reset catch");
				console.error(error);
			}

		} else {
			console.warn('Rrecaptcha not ready...');
		}
	}

	render() {
		return (
			<ReCaptcha
				ref={this.recaptchaRef} {...this.props}
				sitekey={process.env.REACT_APP_RECAPTCHA_ID}
				size='invisible'
			/>
		);
	}
}

InvisibleCaptcha.propTypes = {
};

export default InvisibleCaptcha;
